import React, { useEffect } from "react";
import { useAlert } from '../components/AlertModal'; 
import { useLocation, useNavigate } from "react-router-dom";
import "../styles/PrintPurchaseOrderPage.css";

const PrintPurchaseOrderPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { data, customer } = location.state || {};
  const { showAlert } = useAlert();

  useEffect(() => {
    if (!data || !customer) {
      showAlert("印刷データが見つかりません");
      navigate(-1);
      return;
    }

    const timeout = setTimeout(() => {
      window.print();
      navigate(-1);
    }, 500);

    return () => clearTimeout(timeout);
  }, [data, customer, navigate, showAlert]);

  if (!data || !customer) return null;  


  const {
    purchase_number,
    date,
    total_items,
    total_amount,
    purchase_bonus,
    shipping_adjustment,
    details,
  } = data;

  const {
    name,
    kana,
    address,
    phone_number,
    email,
    birth_date,
    age,
    invoice_number,
  } = customer;
  const item_total = total_amount - purchase_bonus - shipping_adjustment ;
  return (
    <div className="PrintPurchaseOrderPage-purchase-preview">
      <h3>通販買取伝票</h3>
      <div className="PrintPurchaseOrderPage-purchase-header">
        <div className="ppop_purchase_number">買取番号: {purchase_number}</div>
        <div className="ppop_purchase_number">　　日付: {date}</div>
      </div>
      

      <div className="PrintPurchaseOrderPage-customer-info">
        <table className="ppop-customer-info-table">
          <tbody>
            <tr>
              <th>氏名：</th>
              <td>{name}</td>
            </tr>
            <tr>
              <th>フリガナ：</th>
              <td>{kana}</td>
            </tr>
            <tr>
              <th>住所：</th>
              <td>{address}</td>
            </tr>
            <tr>
              <th>電話番号：</th>
              <td>{phone_number}</td>
            </tr>
            <tr>
              <th>メール：</th>
              <td>{email}</td>
            </tr>
            <tr>
              <th>生年月日：</th>
              <td>{birth_date}（{age}歳）</td>
            </tr>
            {invoice_number && (
              <tr>
                <th>インボイス番号：</th>
                <td>{invoice_number}</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="PrintPurchaseOrderPage-purchase-summary">
        <table className="ppop-purchase-summary_table">
          <thead>
            <tr>
              <th>総数</th>
              <th>商品合計</th>
              <th>買取増額</th>
              <th>送料調整</th>
              <th>買取総額</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="ppop_total">{total_items}</td>
              <td >￥{parseFloat(item_total).toLocaleString()}</td>              
              <td>￥{parseFloat(purchase_bonus).toLocaleString()}</td>
              <td>￥{parseFloat(shipping_adjustment).toLocaleString()}</td>
              <td className="ppop_total">￥{parseFloat(total_amount).toLocaleString()}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <table className="PrintPurchaseOrderPage-purchase-details">
        <thead>
          <tr>
            <th className="ppop_id_th">ID</th>
            <th className="ppop_item_name_th">商品名</th>
            <th className="ppop_quantity_th">数</th>
            <th className="ppop_unit_price_th">単価</th>
            <th className="ppop_subtotal_th">小計</th>
            <th className="ppop_condition_th">状態</th>
          </tr>
        </thead>
        <tbody>
          {details.map((d) => (
            <tr key={d.id}>
              <td className="ppop_id">{d.item.id}</td>
              <td className="ppop_item_name">{d.item.item_name}</td>
              <td className="ppop_quantity">{d.quantity}</td>
              <td className="ppop_unit_price">{parseFloat(d.unit_price).toLocaleString()}円</td>
              <td className="ppop_subtotal">{parseFloat(d.subtotal).toLocaleString()}円</td>
              <td className="ppop_condition">{d.condition?.name || "-"}</td>
            </tr>
          ))}
        </tbody>
      </table>


    </div>
  );
};

export default PrintPurchaseOrderPage;
